import { FlyerTemplate } from "../../../../features/flyer-template/types/flyer-template/flyer-template.interface";
import { FlyerTemplateCreatorState } from "./flyer-template-creator-state.interface";

export function createFlyerTemplateCreatorState(): FlyerTemplateCreatorState {
  return {
    canvas: null,
    editingPosition: null,
    errors: null,
    grid: null,
    isLoading: false,
    template: createFlyerEmptyTemplate(),
  };
}

export function createFlyerEmptyTemplate(): FlyerTemplate {
  return {
    id: -1,
    aspectRatio: 1.2941,
    columns: 3,
    name: null,
    positions: [],
    rows: 3,
  };
}
